(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.SidebarController = (function(superClass) {
    extend(SidebarController, superClass);

    function SidebarController(scope, transitions, service, deleteService, state, q, http, timeout, modal, ngModal, stateParams) {
      var hasMessage;
      this.scope = scope;
      this.transitions = transitions;
      this.service = service;
      this.deleteService = deleteService;
      this.state = state;
      this.q = q;
      this.http = http;
      this.timeout = timeout;
      this.modal = modal;
      this.ngModal = ngModal;
      this.stateParams = stateParams;
      this.openUploadedPBIConnections = bind(this.openUploadedPBIConnections, this);
      this.editIrrigationMap = bind(this.editIrrigationMap, this);
      this.openOtherPractices = bind(this.openOtherPractices, this);
      this.loadUploadedPBIConnection = bind(this.loadUploadedPBIConnection, this);
      this.loadPBIConnection = bind(this.loadPBIConnection, this);
      this.loadFpcResults = bind(this.loadFpcResults, this);
      this.copyFieldprint = bind(this.copyFieldprint, this);
      this.stepSaved = bind(this.stepSaved, this);
      this.stepVisited = bind(this.stepVisited, this);
      this.currentStepIs = bind(this.currentStepIs, this);
      this.inFieldprintScore = bind(this.inFieldprintScore, this);
      this.inFieldprintScores = bind(this.inFieldprintScores, this);
      this.inFieldprintProcess = bind(this.inFieldprintProcess, this);
      this.showFullpage = bind(this.showFullpage, this);
      this.viewFieldprintScore = bind(this.viewFieldprintScore, this);
      this.rowClick = bind(this.rowClick, this);
      this.bulkDelete = bind(this.bulkDelete, this);
      this.getClass = bind(this.getClass, this);
      this.gotoStep = bind(this.gotoStep, this);
      this.editFieldprint = bind(this.editFieldprint, this);
      this.editFieldprintClick = bind(this.editFieldprintClick, this);
      this.getBoundaryImage = bind(this.getBoundaryImage, this);
      this.startFieldprint = bind(this.startFieldprint, this);
      this.fieldName = bind(this.fieldName, this);
      this.showCargillMessage = bind(this.showCargillMessage, this);
      this.filterFieldsInDropdown = bind(this.filterFieldsInDropdown, this);
      this.checkOtherPractices = bind(this.checkOtherPractices, this);
      SidebarController.__super__.constructor.apply(this, arguments);
      this.scope.show_fullpage = false;
      this.scope.show_fullpage_fn = this.showFullpage;
      this.scope.selectedClass = 'success';
      this.scope.unselectedClass = '';
      this.scope.selected_options = {
        year: null,
        crop: null,
        field: null
      };
      this.scope.deleteService = this.deleteService;
      this.scope.service = this.service;
      this.scope.years = [];
      this.scope.crops = [];
      this.scope.fields = [];
      this.scope.filteredFields = [];
      this.scope.loading = false;
      this.scope.fpcResults = [];
      this.scope.createError = null;
      this.scope.fieldName = this.fieldName;
      this.scope.isPBIConnected = false;
      this.scope.isUploadedPBIConnected = false;
      this.scope.pbiLauncherOptions = {
        resolve: {
          mode: 'edit',
          field: {},
          year: null,
          hideFieldName: true
        }
      };
      this.scope.uploadedPbiLauncherOptions = {
        mode: 'edit',
        field: {},
        year: null,
        hideFieldName: true
      };
      this.scope.companyName = null;
      this.scope.startFieldprint = this.startFieldprint;
      this.scope.editFieldprint = this.editFieldprint;
      this.scope.editFieldprintClick = this.editFieldprintClick;
      this.scope.inFieldprintProcess = this.inFieldprintProcess;
      this.scope.inFieldprintScores = this.inFieldprintScores;
      this.scope.inFieldprintScore = this.inFieldprintScore;
      this.scope.gotoStep = this.gotoStep;
      this.scope.rowClick = this.rowClick;
      this.scope.bulkDelete = this.bulkDelete;
      this.scope.openOtherPractices = this.openOtherPractices;
      this.scope.editIrrigationMap = this.editIrrigationMap;
      this.scope.resizeTable = 0;
      this.scope.showCargillMessage = this.showCargillMessage;
      this.scope.currentStepIs = this.currentStepIs;
      this.scope.stepVisited = this.stepVisited;
      this.scope.stepSaved = this.stepSaved;
      this.scope.getClass = this.getClass;
      this.scope.copyFieldprint = this.copyFieldprint;
      this.scope.loadFpcResults = this.loadFpcResults;
      this.scope.calculatorSucceeded = this.calculatorSucceeded;
      this.scope.calculatorErrored = this.calculatorErrored;
      this.scope.openUploadedPBIConnections = this.openUploadedPBIConnections;
      this.scope.numSteps = (function(_this) {
        return function() {
          return Object.keys(_this.service.config[_this.service.crop].steps.value).length;
        };
      })(this);
      hasMessage = function(message, fpcResult) {
        var ref, ref1;
        return typeof fpcResult.dryland_response === 'string' && ((ref = fpcResult.dryland_response) != null ? ref.indexOf(message) : void 0) >= 0 || typeof fpcResult.irrigated_response === 'string' && ((ref1 = fpcResult.irrigated_response) != null ? ref1.indexOf(message) : void 0) >= 0;
      };
      this.scope.selected_options.field = null;
      this.loadScopeData(this.service.getYears(), 'years');
      this.loadScopeData(this.service.getCrops(), 'crops');
      this.service.brandNew = false;
      this.service.reset();
      this.scope.selected_options.year = this.service.year;
      this.service.getCrops().then((function(_this) {
        return function(crops) {
          if (crops.data.data.includes(_this.service.crop)) {
            return _this.scope.selected_options.crop = _this.service.crop;
          }
        };
      })(this));
      if (this.stateParams.year || this.stateParams.crop) {
        this.scope.selected_options.year = this.stateParams.year;
        this.scope.selected_options.crop = this.stateParams.crop;
      }
      this.http.post('backend/grower/fieldprint/fields').then((function(_this) {
        return function(response) {
          _this.scope.fields = response.data;
          _this.loadFpcResults();
          _this.loadUploadedPBIConnection();
          return _this.loadPBIConnection(_this.scope.selected_options.year);
        };
      })(this));
      this.http.get('backend/user-info/company').then((function(_this) {
        return function(response) {
          return _this.scope.companyName = response.data.internal_name;
        };
      })(this));
      this.service.onDataLoaded(this.scope, (function(_this) {
        return function() {
          _this.scope.selected_options.year = _this.service.year;
          if (_this.service.crops && _this.service.crops.includes(_this.service.crop)) {
            _this.scope.selected_options.crop = _this.service.crop;
          }
          if (_this.service.crops && _this.service.crops.includes(_this.service.crop)) {
            return _this.scope.selected_options.field = _this.service.field;
          }
        };
      })(this));
      this.scope.$watch('selected_options.year', (function(_this) {
        return function(year, old) {
          if (parseInt(year) === parseInt(old)) {
            return;
          }
          _this.scope.fpcResults = [];
          _this.loadFpcResults();
          _this.loadPBIConnection(year);
          _this.scope.selected_options.field = null;
          return _this.scope.resizeTable += 1;
        };
      })(this));
      this.scope.$watch('selected_options.crop', (function(_this) {
        return function() {
          return _this.scope.resizeTable += 1;
        };
      })(this));
      this.scope.$watchCollection('fpcResults', (function(_this) {
        return function(results) {
          return _this.scope.resizeTable += 1;
        };
      })(this));
      this.scope.$on('app:safelinked', (function(_this) {
        return function() {
          return _this.state.go('grower.fieldprint', {}, {
            reload: 'grower.fieldprint'
          });
        };
      })(this));
      this.scope.$on('fieldprintChanged', (function(_this) {
        return function(event, newFpcResult) {
          _this.ngModal.refreshNavigationAssistantStep('add_fieldprint_analyses');
          if (!newFpcResult || parseInt(newFpcResult.year) !== _this.scope.selected_options.year) {
            return;
          }
          _.remove(_this.scope.fpcResults, function(fpcResult) {
            return fpcResult.id === newFpcResult.id;
          });
          _this.scope.fpcResults.push(newFpcResult);
          return _this.filterFieldsInDropdown();
        };
      })(this));
    }

    SidebarController.prototype.checkOtherPractices = function(year) {
      var filtered;
      filtered = this.scope.fpcResults.filter((function(_this) {
        return function(result) {
          return result.year === parseInt(year);
        };
      })(this));
      return this.scope.hasOtherPractices = filtered.length > 0;
    };

    SidebarController.prototype.filterFieldsInDropdown = function() {
      return this.scope.filteredFields = this.scope.fields.filter((function(_this) {
        return function(field) {
          var fpcResult, i, len, ref;
          ref = _this.scope.fpcResults;
          for (i = 0, len = ref.length; i < len; i++) {
            fpcResult = ref[i];
            if (fpcResult.fields_id === field.field_id) {
              return false;
            }
          }
          return true;
        };
      })(this));
    };

    SidebarController.prototype.showCargillMessage = function() {
      if (this.scope.companyName === 'Cargill' && !this.inFieldprintProcess() && ((this.scope.selected_options.field && this.scope.selected_options.year && this.scope.selected_options.crop) || this.scope.fpcResults.length > 0)) {
        return true;
      }
      return false;
    };

    SidebarController.prototype.fieldName = function(field) {
      if (typeof field !== 'object') {
        field = _.find(this.scope.fields, {
          field_id: field
        });
      }
      return (field != null ? field.farm_name : void 0) + " - " + (field != null ? field.field_name : void 0);
    };

    SidebarController.prototype.startFieldprint = function() {
      this.service.reset();
      return this.service.createFieldprint(this.scope.selected_options.year, this.scope.selected_options.crop, this.scope.selected_options.field).then((function(_this) {
        return function(response) {
          _this.scope.createError = null;
          _this.service.brandNew = true;
          _this.scope.fpcResults.push(response.data);
          return _this.service.gotoStep(0, response.data.id, false);
        };
      })(this))["catch"]((function(_this) {
        return function(error) {
          if (error.status === 422) {
            if (error.data.year.unique) {
              _this.scope.createDuplicateError = true;
            } else {
              _this.scope.createError = JSON.parse(error.data);
            }
            return _this.timeout(function() {
              _this.scope.createError = null;
              return _this.scope.createDuplicateError = null;
            }, 5000);
          }
        };
      })(this));
    };

    SidebarController.prototype.getBoundaryImage = function() {
      return this.http.post('backend/grower/fieldprint/boundary-image', {
        fpcResultId: this.fpcResult.id
      });
    };

    SidebarController.prototype.editFieldprintClick = function(id) {
      if (this.state.includes('grower.fieldprint.score')) {
        return this.state.go('grower.fieldprint').then((function(_this) {
          return function() {
            return _this.editFieldprint(id);
          };
        })(this));
      } else {
        return this.editFieldprint(id);
      }
    };

    SidebarController.prototype.editFieldprint = function(id) {
      this.service.reset();
      this.service.brandNew = false;
      return this.service.loadFieldprint(id).then((function(_this) {
        return function() {
          _this.scope.selected_options.year = _this.service.year;
          if (_this.service.crops && _this.service.crops.includes(_this.service.crop)) {
            _this.scope.selected_options.crop = _this.service.crop;
            _this.scope.selected_options.field = _this.service.field;
            return _this.service.goToFirstIncompleteStep(id);
          }
        };
      })(this));
    };

    SidebarController.prototype.gotoStep = function(stepName) {
      return this.service.gotoStep(this.service.findStepIndexByName(stepName), this.service.fpcResult.id, true, true);
    };

    SidebarController.prototype.getClass = function(row) {
      return row["class"];
    };

    SidebarController.prototype.bulkDelete = function() {
      if (this.state.includes('grower.fieldprint.score')) {
        this.state.go('grower.fieldprint');
      }
      return this.deleteService.toggle(this.scope.fpcResults);
    };

    SidebarController.prototype.rowClick = function(fpcResult, event) {
      if (!(event.target.nodeName === 'TD' || event.target.nodeName === 'DIV')) {
        return;
      }
      if (this.deleteService.active) {
        return this.deleteService.selectRow(fpcResult, this.scope.fpcResults);
      } else {
        return this.viewFieldprintScore(fpcResult, event);
      }
    };

    SidebarController.prototype.viewFieldprintScore = function(fpcResult, event) {
      if (this.state.includes('grower.fieldprint.score') && this.state.params.id === fpcResult.id) {
        return this.state.go('grower.fieldprint');
      } else {
        this.service.fpcResult = fpcResult;
        this.service.year = fpcResult.year;
        this.service.crop = fpcResult.ftm_crop.name;
        this.service.field = fpcResult.fields_id;
        this.scope.pbiLauncherOptions.resolve.field.id = fpcResult.fields_id;
        this.scope.pbiLauncherOptions.resolve.field.name = fpcResult.field.name;
        this.scope.pbiLauncherOptions.resolve.year = fpcResult.year;
        this.scope.uploadedPbiLauncherOptions.field = fpcResult.field;
        this.scope.uploadedPbiLauncherOptions.year = fpcResult.year;
        return this.state.go('grower.fieldprint.score', {
          id: fpcResult.id
        });
      }
    };

    SidebarController.prototype.showFullpage = function() {
      return this.inFieldprintProcess() || this.inFieldprintScores();
    };

    SidebarController.prototype.inFieldprintProcess = function() {
      return this.state.includes('grower.fieldprint.step');
    };

    SidebarController.prototype.inFieldprintScores = function() {
      return this.state.includes('grower.fieldprint.score');
    };

    SidebarController.prototype.inFieldprintScore = function(id) {
      return this.inFieldprintScores() && this.state.params.id === id;
    };

    SidebarController.prototype.currentStepIs = function(stepName) {
      return stepName === this.service.currentStepName;
    };

    SidebarController.prototype.stepVisited = function(stepName) {
      return this.service.visitedSteps.indexOf(stepName) !== -1;
    };

    SidebarController.prototype.stepSaved = function(stepName) {
      return this.service.savedSteps.indexOf(stepName) !== -1;
    };

    SidebarController.prototype.copyFieldprint = function() {
      return this.modal.open({
        windowClass: 'modal-width',
        controller: 'Fieldprint.Controllers.CopyFieldprintController',
        templateUrl: 'backend/grower/fieldprint/copy-fieldprint-dialog',
        scope: this.scope.$new(),
        resolve: {
          fpcResultId: (function(_this) {
            return function() {
              return _this.state.params.id;
            };
          })(this),
          year: (function(_this) {
            return function() {
              return _this.scope.selected_options.year;
            };
          })(this),
          fpcResults: (function(_this) {
            return function() {
              return _this.http.get('backend/grower/fieldprint/fpc-results/all').then(function(response) {
                return response.data;
              });
            };
          })(this),
          fields: (function(_this) {
            return function() {
              return _this.scope.fields;
            };
          })(this)
        }
      }).result.then(this.loadFpcResults);
    };

    SidebarController.prototype.loadFpcResults = function() {
      var year;
      this.ngModal.refreshNavigationAssistantStep('add_fieldprint_analyses');
      this.scope.loading = true;
      year = this.scope.selected_options.year != null ? this.scope.selected_options.year : moment().format('YYYY');
      return this.http.get("backend/grower/fieldprint/fpc-results?year=" + year + "&hide=events,irrigation_map").then((function(_this) {
        return function(response) {
          _this.scope.loading = false;
          _this.scope.fpcResults = response.data;
          _this.checkOtherPractices(year);
          return _this.filterFieldsInDropdown();
        };
      })(this));
    };

    SidebarController.prototype.loadPBIConnection = function(year) {
      return this.http.get('backend/grower/pbi/has-connection', {
        params: {
          year: year
        }
      }).then((function(_this) {
        return function(response) {
          return _this.scope.isPBIConnected = response.data.has_connection;
        };
      })(this));
    };

    SidebarController.prototype.loadUploadedPBIConnection = function() {
      return this.service.hasPBIUploadedConnection(this.service.year).then((function(_this) {
        return function(response) {
          return _this.scope.isUploadedPBIConnected = response.data;
        };
      })(this));
    };

    SidebarController.prototype.openOtherPractices = function() {
      return this.http.post('backend/grower/other-practices/load', {
        year: this.scope.selected_options.year,
        crop: this.scope.selected_options.crop
      }).then((function(_this) {
        return function(response) {
          return _this.modal.open({
            windowClass: 'medlarge_dialog',
            controller: 'Fieldprint.Controllers.OtherPracticesController',
            templateUrl: 'backend/grower/fieldprint/other-practices-dialog',
            scope: _this.scope.$new(),
            resolve: {
              selections: function() {
                return {
                  year: _this.scope.selected_options.year,
                  crop: _this.scope.selected_options.crop
                };
              },
              survey: function() {
                return response.data;
              }
            }
          });
        };
      })(this));
    };

    SidebarController.prototype.editIrrigationMap = function() {
      return this.service.save(this.service.fpcResult.id).then((function(_this) {
        return function() {
          return _this.state.go("grower.fieldprint-edit-zone", {
            request: JSON.stringify({
              year: _this.service.year,
              field_id: _this.service.field,
              crop: _this.service.crop,
              layer_id: _this.service.fpcResult.irrigation_map.id,
              layers_title: _this.service.fpcResult.irrigation_map.name,
              redirectId: _this.state.params.id,
              redirectState: 'fieldprint',
              step: _this.state.params.step
            })
          });
        };
      })(this));
    };

    SidebarController.prototype.openUploadedPBIConnections = function() {
      return this.ngModal.openUploadedPBIConnectionsDialog('edit', this.scope.uploadedPbiLauncherOptions.year, this.scope.uploadedPbiLauncherOptions.field, true).modalRef.result["catch"](_.noop);
    };

    return SidebarController;

  })(Controller);

}).call(this);
